export default "__VITE_ASSET__5a570764__"